<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.name"
            :error-messages="nameErrors"
            :label="$t('global.name')"
            required
            @input="$v.item.name.$touch()"
            @blur="$v.item.name.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.toolHeadDef"
            :error-messages="toolHeadDefErrors"
            :label="$t('tool.toolheaddef')"
            required
            @input="$v.item.toolHeadDef.$touch()"
            @blur="$v.item.toolHeadDef.$touch()"
          />
        </v-col>
      </v-row>

    </v-container>
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'ToolrefForm',
  mixins: [validationMixin],
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
  },
  data() {
    return {
        name: null,
        toolHeadDef: null,
    };
  },
  computed: {

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    nameErrors() {
      const errors = [];

      if (!this.$v.item.name.$dirty) return errors;

      has(this.violations, 'name') && errors.push(this.violations.name);

      !this.$v.item.name.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    toolHeadDefErrors() {
      const errors = [];

      if (!this.$v.item.toolHeadDef.$dirty) return errors;

      has(this.violations, 'toolHeadDef') && errors.push(this.violations.toolHeadDef);

      !this.$v.item.toolHeadDef.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  methods: {
  },
  validations: {
    item: {
      name: {
        required,
      },
      toolHeadDef: {
        required,
      },
    }
  }
};
</script>
